export const PROMOTION_POPUP = 'promotion_popup';

export const PROMOTION_DELAY = 15000; // 9 sec

export const ONE_HOUR_IN_SECONDS = 3600; // 6 months
